import React from "react";

const DiscordWidget = () => {
  return (
    <iframe
      src="https://discord.com/widget?id=934489782225088552&theme=dark"
      width="850"
      height="500"
      allowTransparency="true"
      frameBorder="0"
      sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
      title="Discord Widget"
    ></iframe>
  );
};

export default DiscordWidget;
